export default {
  name: 'App',
  data: function data() {
    return {};
  },
  computed: {
    // 动态设置过渡样式
    direction: function direction() {
      var currentPath = this.$route.path;
      var localRoute = window.myVue && window.myVue.localRoute || [];
      // console.log(localRoute, currentPath);
      var index = localRoute.indexOf(currentPath);
      var tranName = '';
      if (localRoute.length === 0) {
        tranName = 'fade'; // 首页，渐显
      } else if (index >= 0) {
        tranName = 'page-back'; // 回退，右划
      } else {
        tranName = 'page-go'; // 进入新页面，左划
      }

      return tranName;
    }
  },
  watch: {
    $route: function $route(to, from) {
      // console.log(to);
      // console.log(from);
    }
  },
  created: function created() {
    console.log('欢迎访问...');
  },
  methods: {}
};